import React, { Component } from "react";
import { connect, batch } from "react-redux";
import axios from "axios";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import WhoIsOnline from "../../TldrPreview/WhoIsOnline";
import { showCommandKSearch } from "../../_actions/commandKActions";
import { backToDashboard, redirect } from "../../_actions/commonAction";
import {
  captureAndUpdateCover,
  updateStory,
} from "../../_actions/storiesActions";
import {
  wsRedo,
  wsSaveAsTemplate,
  wsUndo,
} from "../../_actions/webSocketAction";
import { closeSlider } from "../../_actions/sidebarSliderActions";
import {
  analyticsTrackEvent,
  dataURItoBlob,
  isWorkspaceOwner,
  vhToPixel,
} from "../../_utils/common";
import { PREVIEW, PROJECTS } from "../../_utils/routes";
import TldrCommentDropdown from "../comment/TldrCommentDropdown";
import { BrandLogo } from "../common/statelessView";
import StoryNameDropDown from "../common/StoryNameDropDown";
import TldrNavDropdown from "../common/TldrNavDropdown";
import TldrShare from "../common/TldrShare";
import {
  StyledStoryNameSubLabel,
  StyledStoryNameInput,
  StyledStoryNameSubBlock,
  StyledDrawer,
  BottomDrawerDivider,
} from "../styled/styles";
import TLDRDownloadOptionsDropDown from "./downloadArtboards/TLDRDownloadOptionsDropDown";
import { EditProjectName } from "../common/statelessView";
import Drawer from "react-bottom-drawer-custom";
import {
  Button,
  IconButton,
  HStack,
  Tooltip,
  Spinner,
  ButtonGroup,
  Flex,
  Text,
  Modal,
  Box,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Divider,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
} from "@chakra-ui/react";
import {
  FaBolt,
  FaChevronDown,
  FaChevronLeft,
  FaChevronUp,
  FaCrown,
  FaDownload,
  FaEllipsisV,
  FaEye,
  FaPen,
  FaRedo,
  FaShare,
  FaUndo,
  FaUserPlus,
} from "react-icons/fa";
import { withTranslation } from "react-i18next";
import format from "string-format";
import PostEditorViewModal from "../social/PostEditorView/PostEditorViewModal";
import * as PostEditorModes from "../social/PostEditor/PostEditorModes.constants";
import { closePostEditor, openPostEditor } from "../../_actions/plannerActions";
import ExportStoryModal from "../../TldrCalendarPlanner/Components/ExportStoryModal";
import { getProjectPostEditorPayload } from "../../TldrCalendarPlanner/utils";
import { SOCIAL_ACCOUNTS_HAS_ACCOUNTS } from "../../_actions/endpoints";
import { showToast } from "../../_utils/showToast";
import NewConnectedAppModal from "../../TldrSettings/TldrConnectedApps/NewConnectedAppModal/NewConnectedAppModal";
import { fetchSocialAccounts } from "../../_actions/socialAccountsActions";
import { isFreePlan } from "../../_utils/isFreePlan";
import TldrTrialEndedModal from "../../TldrSettings/TldrBillingAndPayments/Modals/TldrTrialEndedModal";
import { openUrl } from "@simplified-workspace/shared/util";
import { MdIosShare } from "react-icons/md";

const navStyles = {
  background: "brand.grey-darker",
  boxShadow: "0 8px 16px 0 rgba(0, 0, 0, 0.5)",
  height: "50px",
  position: "sticky",
  zIndex: 1001,
  top: 0,
  alignItems: "center",
  justifyContent: "space-between",
};
export class StudioNavBar extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);

    this.handleFocus = this.handleFocus.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);
    this.state = {
      saving: false,
      showConfirmation: false,
      isPresenting: false,
      showRenameDialog: false,
      visible: false,
      isDownloading: false,
      isPublishing: false,
      isPostEditorExportLoading: false,
      showPostEditorExportStory: false,
      showExportStory: false,
      showNoSocialAccountConnectedModal: false,
      showNewConnectionModal: false,
      isExportPopoverOpen: false,
      showDownloadCount: false,
      showUpgradePlanModal: false,
    };
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  handleFocus(text) {}

  handleFocusOut(text) {
    const storyId = this.props.story.payload.id;
    if (text) {
      this.props.updateStory(storyId, { title: text }, this.signal, {
        ...this.props,
      });
    }
  }

  handleExportStory = () => {
    this.setState({ showExportStory: true });
  };

  handlePostEditorExportStory = () => {
    this.setState({ isPostEditorExportLoading: true });

    const onSuccess = () => {
      this.setState({
        isPostEditorExportLoading: false,
        showPostEditorExportStory: true,
      });
    };

    const onError = () => {
      this.setState({
        isPostEditorExportLoading: false,
        showNoSocialAccountConnectedModal: true,
      });
    };

    axios
      .get(SOCIAL_ACCOUNTS_HAS_ACCOUNTS)
      .then((res) => {
        if (res.data?.status === 1) {
          onSuccess();
        } else {
          onError();
        }
      })
      .catch(() => {
        onError();
      });
  };

  handlePostEditorExportStoryEnd = (data) => {
    const files = data?.urls || [];

    this.setState({
      showPostEditorExportStory: false,
      isDownloading: false,
    });
    this.props.openPostEditor({
      mode: PostEditorModes.CREATE,
      accountsIds: this.props.selectedSocialAccounts,
      addPostMedia: files.map((file) => getProjectPostEditorPayload({ file })),
    });
  };

  downloadingStateChange = (state) => {
    this.setState({
      isDownloading: state,
      isExportPopoverOpen: false,
    });
  };

  publishingStateChange = (state) => {
    this.setState({
      isPublishing: state,
      isExportPopoverOpen: false,
    });
  };

  openRenameDialog = () => {
    this.setState({
      showRenameDialog: true,
    });
  };

  componentDidMount() {
    // Do nothing
  }

  undo = () => {
    this.props.wsUndo();
  };

  redo = () => {
    this.props.wsRedo();
  };

  preview = () => {
    this.setState({
      isPresenting: true,
    });
    analyticsTrackEvent("previewDesign");
    const previewUrl = format(
      PREVIEW,
      this.props.auth.payload.selectedOrg,
      this.props.story.payload.id,
      encodeURIComponent(this.props.story.payload.title)
    );
    openUrl(encodeURI(previewUrl), "_blank");
  };

  saveOnBack = () => {
    const { pageIds } = this.props.pagestore;
    const storyId = this.props.story.payload.id;

    this.setState({
      saving: true,
    });

    if (pageIds.length > 0 && this.props.websockets.snapshot) {
      this.setStoryPageCover(storyId, pageIds[0]);
    } else {
      batch(() => {
        this.props.backToDashboard({ ...this.props });
        this.props.redirect(PROJECTS, { ...this.props });
      });
    }
  };

  render() {
    const { loaded, pageIds } = this.props.pagestore;
    const isEmpty = loaded && pageIds.length > 0;
    const { details } = this.props.websockets;
    const storyFetched = this.props.story.loaded;
    const { undo, redo } = this.props.actions;
    const { orgs, selectedOrg: workspaceId } = this.props.auth.payload;
    const {
      canvasRef,
      story,
      storyPermissionChecks,
      workspacePermissionChecks,
      isMobileView,
    } = this.props;
    const { payload: storyPayload } = story;
    const {
      isExportPopoverOpen,
      showExportStory,
      showNoSocialAccountConnectedModal,
      showConfirmation,
      showNewConnectionModal,
      showPostEditorExportStory,
      showRenameDialog,
      saving,
      isDownloading,
      isPostEditorExportLoading,
      isPresenting,
      isPublishing,
      visible,
    } = this.state;

    const selectedOrg = orgs?.find((item) => item.id === workspaceId);

    const { canShareStory } = storyPermissionChecks;
    const { canViewPublishing } = workspacePermissionChecks;
    const { t } = this.props;
    const isFree = isFreePlan(this.props.subscription.subscribedPlan);
    const isOwner = isWorkspaceOwner(this.props.auth.payload.user);

    return (
      <>
        <Flex sx={navStyles} px={isMobileView ? "2.5" : "4"}>
          <HStack alignItems="center">
            <Box
              onClick={(e) => {
                e.stopPropagation();
                this.saveOnBack();
              }}
              display={["none", "none", "block"]}
            >
              {" "}
              <BrandLogo />
            </Box>

            <HStack as={"nav"} m={0}>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  this.saveOnBack();
                }}
                size="sm"
                fontSize="lg"
                isLoading={saving}
                icon={<FaChevronLeft />}
                spinner={<Spinner size="sm" color="brand.primary" />}
              />
              <ButtonGroup size="sm" isAttached>
                <IconButton
                  disabled={!undo}
                  onClick={(e) => this.undo()}
                  icon={<FaUndo />}
                  size="sm"
                  fontSize="lg"
                  mr={1}
                />
                <IconButton
                  disabled={!isEmpty || !redo}
                  onClick={(e) => this.redo()}
                  icon={<FaRedo />}
                  size="sm"
                  fontSize="lg"
                />
              </ButtonGroup>

              <Flex display={["none", "none", "inline-block"]}>
                {storyFetched && (
                  <StoryNameDropDown
                    props={this.props}
                    title={this.props.story.payload.title}
                    contentSize={this.props.story.contentSize}
                    last_updated={this.props.story.payload.last_updated}
                  />
                )}
              </Flex>
              <Flex display={["none", "none", "inline-block"]}>
                {storyFetched && (
                  <StyledStoryNameSubBlock>
                    <StyledStoryNameInput onClick={this.openRenameDialog}>
                      {this.props.story.payload.title}
                    </StyledStoryNameInput>
                    <StyledStoryNameSubLabel>{details}</StyledStoryNameSubLabel>
                  </StyledStoryNameSubBlock>
                )}
              </Flex>
              {isOwner && isFree && (
                <Button
                  leftIcon={<Icon color="brand.primary" as={FaCrown} />}
                  ml={4}
                  size="sm"
                  onClick={() => {
                    analyticsTrackEvent("upgradePlan");
                    this.setState({ showUpgradePlanModal: true });
                  }}
                >
                  {t("upgrade_btn")}
                </Button>
              )}
            </HStack>
          </HStack>
          <HStack>
            <Flex display={["none", "none", "inline-block"]}>
              <WhoIsOnline />
            </Flex>
            <Flex display={["none", "none", "inline-block"]}>
              {process.env.REACT_APP_DEBUG === "True" && (
                <IconButton
                  onClick={() => this.exportToJSON()}
                  icon={<FaDownload />}
                  size="sm"
                  fontSize="lg"
                  variant="ghost"
                />
              )}
            </Flex>
            <Flex display={["none", "none", "inline-block"]}>
              <TldrCommentDropdown />
            </Flex>
            <Flex display={["none", "none", "inline-block"]}>
              <Tooltip
                hasArrow
                label={
                  <Flex direction="column" p={2} align="center">
                    <Text color="gray.100" mb={1} fontSize={14}>
                      {t("shortcut.tooltip.title")}
                    </Text>
                    <Text color="gray.300" mb={1}>
                      {t("shortcut.tooltip.subtitle")}
                    </Text>
                    <Text fontSize={18}>
                      <kbd>Ctrl</kbd> <kbd>K</kbd>
                    </Text>
                  </Flex>
                }
                shouldWrapChildren
              >
                <IconButton
                  onClick={this.showCommandK}
                  disabled={!isEmpty}
                  icon={<FaBolt />}
                  size="sm"
                  fontSize="lg"
                  variant="ghost"
                />
              </Tooltip>
            </Flex>
            <Flex
              display={["none", "none", "inline-block"]}
              h={8}
              borderLeft="1px solid"
              borderColor="gray.300"
              opacity="0.5"
            />
            <Flex display={["none", "none", "inline-block"]}>
              <Tooltip hasArrow label={t("tooltip_preview")}>
                <IconButton
                  onClick={this.preview}
                  disabled={!isEmpty}
                  icon={<FaEye />}
                  size="sm"
                  fontSize="lg"
                  variant="ghost"
                />
              </Tooltip>
            </Flex>

            {canShareStory && (
              <Flex display={["none", "none", "inline-block"]}>
                <Tooltip hasArrow label={t("navbar.tooltip.share")}>
                  <Button
                    variant="solid"
                    disabled={!isEmpty}
                    onClick={this.share}
                    size="sm"
                    leftIcon={<FaUserPlus />}
                    fontSize="md"
                  >
                    {t("navbar.button.share")}
                  </Button>
                </Tooltip>
              </Flex>
            )}

            <Menu
              isLazy
              closeOnSelect={false}
              isOpen={isExportPopoverOpen}
              onClose={() =>
                this.setState({
                  isExportPopoverOpen: false,
                })
              }
              onOpen={() =>
                this.setState({
                  showExportStory: false,
                  showPostEditorExportStory: false,
                })
              }
            >
              {({ isOpen }) => (
                <>
                  <MenuButton
                    as={Button}
                    rightIcon={isOpen ? <FaChevronUp /> : <FaChevronDown />}
                    size="sm"
                    onClick={() => this.setState({ isExportPopoverOpen: true })}
                    isLoading={isDownloading}
                    loadingText={t("download_loading_text", { ns: "common" })}
                  >
                    {!isMobileView ? (
                      t("export", { ns: "common" })
                    ) : (
                      <MdIosShare size={22} />
                    )}
                  </MenuButton>
                  <MenuList
                    px={
                      !showExportStory && !showPostEditorExportStory ? "0" : "4"
                    }
                    w={
                      !showExportStory && !showPostEditorExportStory
                        ? ""
                        : "360px"
                    }
                  >
                    {!showExportStory && !showPostEditorExportStory ? (
                      <>
                        <MenuItem
                          icon={<FaDownload />}
                          onClick={this.handleExportStory}
                        >
                          {t("download_now", { ns: "common" })}
                        </MenuItem>
                        <MenuItem
                          icon={<FaShare />}
                          onClick={this.handlePostEditorExportStory}
                        >
                          {t("share_on_social", { ns: "common" })}
                        </MenuItem>
                      </>
                    ) : showExportStory ? (
                      <TLDRDownloadOptionsDropDown
                        disabled={!isEmpty}
                        canvasRef={canvasRef}
                        onDownloading={this.downloadingStateChange}
                        story={story}
                        onClose={() =>
                          this.setState({ showExportStory: false })
                        }
                      />
                    ) : showPostEditorExportStory ? (
                      <ExportStoryModal
                        story={story}
                        onClose={() =>
                          this.setState({ showPostEditorExportStory: false })
                        }
                        onDownloading={this.downloadingStateChange}
                        onExportEnd={this.handlePostEditorExportStoryEnd}
                        showHeader
                      />
                    ) : null}
                  </MenuList>
                </>
              )}
            </Menu>

            {!isDownloading && (
              <Flex display={["inline-block", "inline-block", "none"]}>
                <IconButton
                  icon={<FaEllipsisV />}
                  onClick={() => {
                    this.setState(
                      (prevState) => {
                        return { visible: !prevState.visible };
                      },
                      () => {
                        this.props.closeSlider();
                        this.props.onExtendedDrawerStateChange(visible);
                      }
                    );
                  }}
                  cursor="pointer"
                  size="sm"
                  fontSize="lg"
                  variant="ghost"
                />
              </Flex>
            )}

            <Flex display={["none", "none", "inline-block"]}>
              <TldrNavDropdown />
            </Flex>
          </HStack>
        </Flex>

        {showConfirmation && (
          <TldrShare
            org={selectedOrg}
            contentType="story"
            contentId={storyPayload.id}
            onHide={() => {
              this.setState({
                ...this.state,
                showConfirmation: false,
              });
            }}
          />
        )}

        <Modal
          isOpen={showRenameDialog}
          onClose={(e) => this.setState({ showRenameDialog: false })}
          size="sm"
          isCentered
        >
          <EditProjectName
            props={this.props}
            handleCloseAddModal={(e) =>
              this.setState({ showRenameDialog: false })
            }
            signal={this.signal}
          ></EditProjectName>
        </Modal>

        <Flex display={["inline-block", "inline-block", "none"]}>
          <StyledDrawer>
            <Drawer
              className="drawer"
              isVisible={visible}
              drawerHeight={vhToPixel(40)}
              hideScrollbars="true"
              onClose={() => {
                this.setState(
                  (prevState) => {
                    return { visible: false };
                  },
                  () => {
                    this.props.onExtendedDrawerStateChange(false);
                  }
                );
              }}
            >
              <StyledStoryNameSubBlock>
                <StyledStoryNameInput onClick={this.openRenameDialog}>
                  {this.props.story.payload.title}
                  <FaPen color="gray.300" />
                </StyledStoryNameInput>
                <StyledStoryNameSubLabel>{details}</StyledStoryNameSubLabel>
              </StyledStoryNameSubBlock>
              <BottomDrawerDivider />
              {canViewPublishing ? (
                <Button
                  disabled={!isEmpty}
                  isLoading={isPostEditorExportLoading}
                  onClick={() => {
                    this.setState(
                      {
                        visible: false,
                      },
                      () => {
                        this.props.onExtendedDrawerStateChange(false);
                        this.handlePostEditorExportStory();
                      }
                    );
                  }}
                  iconSpacing={8}
                  leftIcon={<FaShare />}
                  variant="unstyled"
                  ml={8}
                  mt={4}
                  fontWeight={400}
                  display="block"
                >
                  {t("navbar.button.publish")}
                </Button>
              ) : null}

              <Button
                disabled={!isEmpty}
                onClick={() => {
                  this.setState(
                    (prevState) => {
                      return { visible: false };
                    },
                    () => {
                      this.props.onExtendedDrawerStateChange(false);
                      this.share();
                    }
                  );
                }}
                iconSpacing={8}
                leftIcon={<FaUserPlus />}
                variant="unstyled"
                ml={8}
                fontWeight={400}
              >
                {t("navbar.button.share")}
              </Button>

              <div
                onClick={() => {
                  this.setState(
                    (prevState) => {
                      return { visible: false };
                    },
                    () => {
                      this.props.onExtendedDrawerStateChange(false);
                    }
                  );
                }}
              >
                <TldrCommentDropdown />
              </div>
              <Button
                onClick={() => {
                  this.setState(
                    (prevState) => {
                      return { visible: false };
                    },
                    () => {
                      this.props.onExtendedDrawerStateChange(false);
                      this.preview();
                    }
                  );
                }}
                disabled={!isEmpty}
                iconSpacing={8}
                leftIcon={<FaEye />}
                variant="unstyled"
                ml={8}
                fontWeight={400}
              >
                {t("navbar.button.preview")}
              </Button>
            </Drawer>
          </StyledDrawer>
        </Flex>

        {this.props.postEditorData ? (
          <PostEditorViewModal
            onClose={() => {
              this.props.closePostEditor();
            }}
            onActionDone={() => {
              this.props.closePostEditor();
            }}
            defaultAccountsIds={this.props.postEditorData.accountsIds}
            defaultPostData={this.props.postEditorData.postData}
            addPostMedia={this.props.postEditorData.addPostMedia}
            mode={this.props.postEditorData.mode}
          />
        ) : null}

        {showNoSocialAccountConnectedModal ? (
          <Modal
            isOpen={showNoSocialAccountConnectedModal}
            onClose={this.closeNoSocialAccountConnectedModal}
            isCentered
            size="sm"
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>
                {t("export_project.no_accounts.title", {
                  ns: "planner",
                })}
              </ModalHeader>
              <ModalCloseButton />

              <Divider my="2" />
              <ModalBody>
                {t("export_project.no_accounts.message", {
                  ns: "planner",
                })}
              </ModalBody>

              <Divider my="2" />
              <ModalFooter>
                <Button
                  mr={3}
                  onClick={this.closeNoSocialAccountConnectedModal}
                >
                  {t("cancel", { ns: "common" })}
                </Button>
                <Button variant="solid" onClick={this.onConnectAccountClick}>
                  {t("new_connection.connect")}
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        ) : null}

        <NewConnectedAppModal
          onAddNewPartner={this.addNewAndFetchConnection}
          show={showNewConnectionModal}
          handleModalClose={this.closeShowNewConnectionModal}
          showOnlySocial
        ></NewConnectedAppModal>
        {this.state.showUpgradePlanModal ? (
          <TldrTrialEndedModal
            show={this.state.showUpgradePlanModal}
            onHide={() => this.setState({ showUpgradePlanModal: false })}
          />
        ) : null}
      </>
    );
  }

  exportToJSON = () => {
    const objects = this.props.canvasRef.handler.exportJSON().filter((obj) => {
      if (!obj.id) {
        return false;
      }
      return true;
    });
    // const { animations, styles, dataSources } = this.state;
    const exportDatas = {
      objects,
      // animations,
      // styles,
      // dataSources,
    };
    const anchorEl = document.createElement("a");
    anchorEl.href = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(exportDatas, null, "\t")
    )}`;
    anchorEl.download = `${
      this.props.canvasRef.handler.workarea.name || "sample"
    }.json`;
    document.body.appendChild(anchorEl); // required for firefox
    anchorEl.click();
    anchorEl.remove();
  };

  setStoryPageCover = (storyId, pageId, saveAsTemplate) => {
    const { canvasRef, t } = this.props;
    let imageQuality = 0.2;
    let fileType = "jpeg";

    let fileName = `${pageId}_${Date.now()}.${fileType}`;

    const dataURL = canvasRef.handler.getArtBoardAsDataURL({
      format: fileType,
      quality: imageQuality,
      name: fileName,
    });

    if (!dataURL) {
      showToast({
        description: t("errors.something_went_wrong", { ns: "common" }),
        title: t("errors.cover_image_error", { ns: "common" }),
        status: "error",
      });
      this.props.backToDashboard();
      this.props.redirect(PROJECTS, this.props);
      return;
    }

    let file = new File([dataURItoBlob(dataURL)], fileName, {
      type: "image/jpeg",
    });

    this.props.captureAndUpdateCover(
      storyId,
      file,
      saveAsTemplate,
      this.signal,
      {
        ...this.props,
      }
    );
  };

  share = () => {
    this.setState({
      showConfirmation: true,
    });
  };

  edit = () => {
    this.setState({
      isPresenting: false,
    });
  };

  showCommandK = () => {
    analyticsTrackEvent("showCommandK");
    this.props.showCommandKSearch();
  };

  closeNoSocialAccountConnectedModal = () => {
    this.setState({ showNoSocialAccountConnectedModal: false });
  };

  onConnectAccountClick = () => {
    this.setState({
      showNewConnectionModal: true,
    });
  };

  closeShowNewConnectionModal = () => {
    this.setState({ showNewConnectionModal: false });
  };

  addNewAndFetchConnection = () => {
    const { t } = this.props;

    this.props
      .fetchSocialAccounts({ selectNewAccounts: true })
      .then((response) => {
        showToast({
          description: t("connection_success_message"),
          title: t("success", { ns: "common" }),
          status: "success",
        });
      });
  };
}

const mapStateToProps = (state) => ({
  pagestore: state.pagestore,
  websockets: state.websockets,
  story: state.story,
  editor: state.editor,
  session: state.session,
  actions: state.actions,
  auth: state.auth,
  storyPermissionChecks: state.permissions.storyPermissionChecks,
  workspacePermissionChecks: state.permissions.workspacePermissionChecks,
  postEditorData: state.plannerStore.postEditorData,
  selectedSocialAccounts: state.socialAccountsStore.selected,
  isMobileView: state.app.isMobileView,
  subscription: state.subscription,
});

StudioNavBar.propTypes = {
  websockets: PropTypes.object.isRequired,
  pagestore: PropTypes.object.isRequired,
  story: PropTypes.object.isRequired,
  editor: PropTypes.object.isRequired,
  session: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  backToDashboard: (props) => dispatch(backToDashboard(props)),
  updateStory: (storyId, data, signal, props) =>
    dispatch(updateStory(storyId, data, signal, props)),
  captureAndUpdateCover: (
    storyId,
    file,
    saveAsTemplate,
    signal,
    props,
    templateName
  ) =>
    dispatch(
      captureAndUpdateCover(
        storyId,
        file,
        saveAsTemplate,
        signal,
        props,
        templateName
      )
    ),
  redirect: (url, props) => dispatch(redirect(url, props)),
  wsSaveAsTemplate: (pageId) => dispatch(wsSaveAsTemplate(pageId)),
  wsUndo: () => dispatch(wsUndo()),
  wsRedo: () => dispatch(wsRedo()),
  showCommandKSearch: () => dispatch(showCommandKSearch()),
  closeSlider: () => dispatch(closeSlider()),
  openPostEditor: (data) => dispatch(openPostEditor(data)),
  closePostEditor: () => dispatch(closePostEditor()),
  fetchSocialAccounts: (data) => dispatch(fetchSocialAccounts(data)),
});

export default withTranslation(["navbar", "planner"])(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(StudioNavBar))
);
